exports.config = {
  apiKey: "AIzaSyCBnSsyN04IExh9eZrwUzvnTaR-WzaGQLY",
  authDomain: "advacon-quick-check.firebaseapp.com",
  databaseURL: "https://advacon-quick-check.firebaseio.com",
  projectId: "advacon-quick-check",
  storageBucket: "advacon-quick-check.appspot.com",
  messagingSenderId: "493198954838",
  appId: "1:493198954838:web:7a34df101eb4408f3686f7",
  measurementId: "G-BD0VLXGPG3",
};
